import { apiClient } from 'api'
import { TrainingField } from 'types/fields'

type NewItem = Omit<TrainingField, 'id'>

export const getTrainingFields = () => apiClient.get<TrainingField[]>('/training-fields')

export const getTrainingFieldById = (fieldId: number) => apiClient.get<TrainingField>(`/training-fields/${fieldId}`)

export const createTrainingField = (field: NewItem) => apiClient.post<NewItem, TrainingField>('/training-fields', field)

export const editTrainingField = (field: TrainingField) =>
    apiClient.patch<TrainingField>(`/training-fields/${field.id}`, field)

export const deleteTrainingField = (id: number) => apiClient.delete(`/training-fields/${id}`)
